export default __webpack_public_path__ + "static/media/close.2d2cd120.svg";